export const appendUniqueMessage = (messages, message) => {
  if (!message?.id) return messages;
  return messages.some((item) => Number(item.id) === Number(message.id))
    ? messages
    : [message, ...messages];
};
